/**
 * NewsLetter Module
 *
 * This module handles newsletter subscription functionality
 */

import jQuery from 'jquery';

const NewsLetter = {
  /**
   * Initialize newsletter subscription form
   */
  init: function () {
    this.setupFormSubmission();
    this.setupFormValidation();
  },

  /**
   * Set up form submission handler
   */
  setupFormSubmission: function () {
    const form = jQuery('.newsletter-form');

    form.on('submit', (e) => {
      e.preventDefault();

      // Get form data
      const email = jQuery('#newsletter-email').val();

      // Basic validation
      if (!this.validateEmail(email)) {
        this.showError('Please enter a valid email address');
        return;
      }

      // Show loading state
      this.showLoading(true);

      // Simulate API call to subscribe user
      this.subscribeUser(email)
        .then((response) => {
          this.showLoading(false);
          this.showSuccess('Thank you for subscribing!');
          form[0].reset();
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message || 'An error occurred. Please try again.');
        });
    });
  },

  /**
   * Set up form validation
   */
  setupFormValidation: function () {
    const emailInput = jQuery('#newsletter-email');

    emailInput.on('input', () => {
      const email = emailInput.val();

      if (email && !this.validateEmail(email)) {
        emailInput.addClass('invalid');
      } else {
        emailInput.removeClass('invalid');
      }
    });

    emailInput.on('focus', () => {
      this.clearMessages();
    });
  },

  /**
   * Validate email format
   * @param {string} email - Email address to validate
   * @returns {boolean} - True if email is valid
   */
  validateEmail: function (email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  },

  /**
   * Subscribe user to newsletter
   * @param {string} email - User's email address
   * @returns {Promise} - Promise resolving with subscription result
   */
  subscribeUser: function (email) {
    return new Promise((resolve, reject) => {
      // Simulate API call with setTimeout
      setTimeout(() => {
        // 90% chance of success
        if (Math.random() < 0.9) {
          resolve({ success: true });
        } else {
          reject({ message: 'Server error. Please try again.' });
        }
      }, 1500);
    });
  },

  /**
   * Show loading state
   * @param {boolean} isLoading - Whether to show or hide loading state
   */
  showLoading: function (isLoading) {
    const submitBtn = jQuery('.newsletter-submit');

    if (isLoading) {
      submitBtn.addClass('loading');
      submitBtn.prop('disabled', true);
    } else {
      submitBtn.removeClass('loading');
      submitBtn.prop('disabled', false);
    }
  },

  /**
   * Show success message
   * @param {string} message - Success message to display
   */
  showSuccess: function (message) {
    const messageEl = jQuery('.newsletter-message');
    messageEl.removeClass('error').addClass('success');
    messageEl.text(message);
    messageEl.fadeIn();
  },

  /**
   * Show error message
   * @param {string} message - Error message to display
   */
  showError: function (message) {
    const messageEl = jQuery('.newsletter-message');
    messageEl.removeClass('success').addClass('error');
    messageEl.text(message);
    messageEl.fadeIn();
  },

  /**
   * Clear status messages
   */
  clearMessages: function () {
    const messageEl = jQuery('.newsletter-message');
    messageEl.fadeOut(() => {
      messageEl.removeClass('success error');
      messageEl.text('');
    });
  },
};

export default NewsLetter;
